import { AfterViewInit, Component, Inject, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { UiAtomButtonComponent } from '../../atoms/ui-atom-button/ui-atom-button.component';
import { UiAtomTextComponent } from '../../atoms/ui-atom-text/ui-atom-text.component';
import { TranslateModule } from '@ngx-translate/core';

export interface UiMoleculeDialogDeleteWithConfirmData {
  /** Clave de traducción para el título (por defecto: dialogs.deleteWithConfirm.title) */
  titleKey?: string;
  titleParams?: Record<string, any>;

  /** Clave de traducción para el mensaje (por defecto: dialogs.deleteWithConfirm.message) */
  messageKey?: string;
  messageParams?: Record<string, any>;

  /** Clave de traducción para el checkbox (por defecto: dialogs.deleteWithConfirm.checkbox) */
  checkboxLabelKey?: string;
  checkboxLabelParams?: Record<string, any>;

  /** Claves para personalizar el botón de confirmar (por defecto: buttons.delete) */
  confirmButtonKey?: string;
  confirmButtonParams?: Record<string, any>;

  /** Claves para personalizar el botón de cancelar (por defecto: buttons.cancel) */
  cancelButtonKey?: string;
  cancelButtonParams?: Record<string, any>;
}

@Component({
  selector: 'ui-molecule-dialog-delete-with-confirm',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCheckbox,
    UiAtomButtonComponent,
    UiAtomTextComponent,
    TranslateModule,
  ],
  templateUrl: './ui-molecule-dialog-delete-with-confirm.component.html',
  styleUrls: ['./ui-molecule-dialog-delete-with-confirm.component.scss'],
})
export class UiMoleculeDialogDeleteWithConfirmComponent implements AfterViewInit {
  form: FormGroup;

  @ViewChildren(UiAtomButtonComponent)
  buttons!: QueryList<UiAtomButtonComponent>;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UiMoleculeDialogDeleteWithConfirmComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: UiMoleculeDialogDeleteWithConfirmData
  ) {
    const hasCheckbox = !!data.checkboxLabelKey;
    this.form = this.fb.group({
      confirm: [hasCheckbox ? false : true, hasCheckbox ? [Validators.requiredTrue] : []],
    });
  }

  ngAfterViewInit(): void {
    // Focus en el primer botón del diálogo
    if (this.buttons && this.buttons.length > 0) {
      this.buttons.first.focus();
    }
  }

  submit(): void {
    if (this.form.valid) {
      this.dialogRef.close(true);
    } else {
      this.form.markAllAsTouched();
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  // Helpers para claves por defecto
  get titleKey(): string {
    return this.data.titleKey || 'dialogs.deleteWithConfirm.title';
  }

  get messageKey(): string {
    return this.data.messageKey || 'dialogs.deleteWithConfirm.message';
  }

  get checkboxKey(): string {
    return this.data.checkboxLabelKey || 'dialogs.deleteWithConfirm.checkbox';
  }

  get confirmKey(): string {
    return this.data.confirmButtonKey || 'buttons.delete';
  }

  get cancelKey(): string {
    return this.data.cancelButtonKey || 'buttons.cancel';
  }
}
